import CryptoJS from 'crypto-js';
import translatedCharacters from "./translatedCharacters";
import store from '@/store'
import useJwt from '@/auth/jwt/useJwt'

const key = window["VUE_APP_AES_KEY"] ? window["VUE_APP_AES_KEY"] : 'rdxHsW4Cg27yIAjE0nmELMvrpapJzJD3';
const iv = window["VUE_APP_AES_IV"] ? window["VUE_APP_AES_IV"] : 'rDaFHH76C0B2YhUl';

export function encrypt(text) {
    const encrypt = text + "-" + new Date().getTime()

    var ciphertext = CryptoJS.AES.encrypt(encrypt, CryptoJS.SHA256(CryptoJS.enc.Utf8.parse(key)), {
        iv: CryptoJS.SHA256(CryptoJS.enc.Utf8.parse(iv)),
        padding: CryptoJS.pad.Pkcs7,
        mode: CryptoJS.mode.CBC
    }).toString();

    return ciphertext;
}

export function decrypt(text) {
    var ciphertext = CryptoJS.AES.decrypt(text, key, {
        iv: iv,
        padding: CryptoJS.pad.Pkcs7,
        mode: CryptoJS.mode.CBC
    });

    return ciphertext.toString(CryptoJS.enc.Utf8);
}

export function e2eEncrypt(text) {
    const encrypt = text;
    const userData = store.state.profile.email
        ? store.state.profile
        : JSON.parse(localStorage.getItem(useJwt.jwtConfig.storageUserDataKeyName));
    const key = translate(userData.appSecret.substring(16, 32));
    const iv = translate(userData.appId + userData.appSecret.substring(0, 15));

    var ciphertext = CryptoJS.AES.encrypt(encrypt, CryptoJS.SHA256(CryptoJS.enc.Utf8.parse(key)), {
        iv: CryptoJS.SHA256(CryptoJS.enc.Utf8.parse(iv)),
        padding: CryptoJS.pad.Pkcs7,
        mode: CryptoJS.mode.CBC
    }).toString();

    return ciphertext;
}

export function e2eDecrypt(text) {
    const userData = store.state.profile.email
        ? store.state.profile
        : JSON.parse(localStorage.getItem(useJwt.jwtConfig.storageUserDataKeyName));
    const key = translate(userData.appSecret.substring(16, 32));
    const iv = translate(userData.appId + userData.appSecret.substring(0, 15));

    var ciphertext = CryptoJS.AES.decrypt(text, CryptoJS.SHA256(CryptoJS.enc.Utf8.parse(key)), {
        iv: CryptoJS.SHA256(CryptoJS.enc.Utf8.parse(iv)),
        padding: CryptoJS.pad.Pkcs7,
        mode: CryptoJS.mode.CBC
    });

    return ciphertext.toString(CryptoJS.enc.Utf8);
}

export function translate(text) {
    let newText = "";

    for (let i = 0; i < text.length; i++) {
        newText += translatedCharacters[text[i]] ? translatedCharacters[text[i]] : text[i];
    }

    return newText;
}